<script setup lang="ts">
import type { SectionsImageColumnsGroup } from '@autobid/strapi-integration/rest/components'
import CommonLink from '@autobid/ui/components/common/Link.vue'
import StrapiImage from '@autobid/ui/components/common/strapi/Image.vue'
import CommonTooltip from '@autobid/ui/components/common/Tooltip.vue'
import { getImageStyles } from '@autobid/ui/utils/cva/getImageStyles'

interface Props {
  data: SectionsImageColumnsGroup
}

defineProps<Props>()
</script>

<template>
  <elements-expander
    v-if="data"
    :expander="data.expander"
    class="-mx-2 my-4 flex flex-wrap items-end gap-y-2"
    :class="{
      'flex-row-reverse': data?.directionReverse,
      'grid grid-cols-2 md:flex': data?.maxPicturesInRowOnMobile === 'two',
      'justify-end': data.alignedContent?.name === 'right',
      'justify-center': data.alignedContent?.name === 'center',
    }"
  >
    <component
      :is="image.url ? CommonLink : 'div'"
      v-for="(image, index) of data?.pictures"
      :key="image.id"
      v-bind="{
        ...(image.url?.length ? { href: image.url } : {}),
      }"
      :class="[
        getImageStyles({ desktopWidth: image.width }),
        index === data.pictures!.length - 1 && index % 2 === 0
          ? 'col-span-2'
          : '',
      ]"
    >
      <component
        :is="image.title?.length ? CommonTooltip : 'span'"
        :tooltip="image.title"
      >
        <StrapiImage
          v-if="image.image"
          :data="image.image"
          class="mx-2 h-auto w-full"
        />
      </component>
    </component>
  </elements-expander>
</template>
